<template>
  <div class="locker-code-container">
    <p>
      Are you a returning user with a Locker Code?
      <strong @click="handleShowLocker()">CLICK HERE</strong>
    </p>
    <input
      name="locker-code"
      class="input-style form-control"
      v-show="showLockerCode"
      v-model="lockerCode"
      maxlength="10"
    />

    <button
      class="btn btn-black next-step"
      @click="goToLocker()"
      v-show="showLockerCode"
    >
      {{ loadingLocker ? "Loading..." : "Go to Locker" }}
    </button>
    <span v-if="loadingLockerError" class="error" v-show="showLockerCode">{{
      loadingLockerError
    }}</span>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  name: "GoToLocker",

  computed: {
    ...mapState("lockerModule", ["loadingLocker", "loadingLockerError"]),

    hasLockerCode() {
      return this.lockerCode.trim().length > 0;
    },
  },

  methods: {
    ...mapActions("lockerModule", ["getLockerByCode"]),
    ...mapActions("project", ["redirectToLocker"]),

    async goToLocker() {
      if (this.hasLockerCode) {
        try {
          await this.getLockerByCode(this.lockerCode);
          if (!this.loadingLockerError) {
            this.redirectToLocker();
          }
        } catch (error) {
          console.log(error);
        }
      }
    },

    handleShowLocker() {
      this.showLockerCode = !this.showLockerCode;
    },
  },

  data() {
    return {
      lockerCode: "",
      showLockerCode: false,
    };
  },
};
</script>